'use strict';

var Promise = require('bluebird');

function readAsDataURL (file) {
  if (!file || !window.FileReader) {
    return Promise.resolve(null);
  }

  return new Promise(function (resolve, reject) {
    var reader = new window.FileReader();
    reader.onload = function () {
      return resolve(reader.result);
    };
    reader.readAsDataURL(file);
  });
}

function readAsBase64 (file) {
  return readAsDataURL(file)
    .then(function (data) {
      if (!data) {
        return null;
      }
      return data.replace(/^data:.*;base64,/, '');
    });
}

module.exports.readAsDataURL = readAsDataURL;
module.exports.readAsBase64 = readAsBase64;
